import { ReactNode } from 'react';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import Text14 from '@sdk/components/ui/typography/Text14';

type Props = {
  children: ReactNode;
};

export const ComposeConversationSubtitle = ({ children }: Props) => (
  <Text14 themeColor={ThemeColorType.gray}>{children}</Text14>
);
